
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>B.Sc.  Economics  </h1>
                </div>
            </div>
        </div>          
    </div>  
</section>    

<section class="section-lg std-scholarship">
    <div class="container">
        <div class="row row-50">
            <div class="col-md-3">
                <div class="vertical-tabs">
                    <ul class="nav nav-pills flex-column" id="myTab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab" aria-controls="tab1" aria-selected="true">Eligibility </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab" aria-controls="tab2" aria-selected="false">Duration</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3" aria-selected="false">Subjects</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4" aria-selected="false">Affiliation</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab5-tab" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab5" aria-selected="false">Scope  and Prospects</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab6-tab" data-toggle="tab" href="#tab6" role="tab" aria-controls="tab6" aria-selected="false">Fees And Intake</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-9">
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
                        <div class="inner-title"  >
                            <h3>Eligibility </h3>                           
                           
                        </div>
                        <div class="text-left">
                            <p>10+2 or any other equivalent examination from a recognized board. Aspirants must have studied Mathematics or Statistics as a compulsory subject in Class 12 Age must be below 25 years.</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">                                
                        <div class="inner-title"  >
                            <h3>Duration
                            </h3>
                           
                        </div>  
                        <div class="text-left">                        
                            <p>3 years ( 6 Semesters)</p>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">                                
                        <div class="inner-title"  >
                            <h3>Subjects
                            </h3>
                           
                        </div>
                        <p>5 subjects per semester </p>
                        <!-- <div class="table-responsive" > 
                            <table class="table table-bordered text-center tbl_custom">
                                <thead>
                                    <tr>
                                        <th colspan="4">MCM Part I</th>
                                    </tr>
                                    <tr>
                                        <th width="15%">Course Code</th>
                                        <th width="30%">Semester- 1</th>
                                        <th width="15%">Course Code </th>
                                        <th width="30%">Semester- 2</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1CM1</td>
                                        <td>Fundamental of Information Technology</td>
                                        <td>2CM1</td>
                                        <td>Management Information Systems</td>
                                    </tr>
                                    <tr>
                                        <td>1CM2</td>
                                        <td>Programming in C & OOPs Concept</td>
                                        <td>2CM2</td>
                                        <td>Core Java</td>
                                    </tr>
                                    <tr>
                                        <td>1CM3</td>
                                        <td>Introduction to Operating Systems</td>
                                        <td>2CM3</td>
                                        <td>Quantity Techniques & Operation Research</td>
                                    </tr>
                                    <tr>
                                        <td>1CM4</td>
                                        <td>Computerized Accounting (Tally ERP 9)</td>
                                        <td>2CM4</td>
                                        <td>E-Commerce and Web Designing</td>
                                    </tr>
                                    <tr>
                                        <td>1CM5</td>
                                        <td>Practical-I :Programming in C & Operating Systems</td>
                                        <td>2CM5</td>
                                        <td>Practical-I :Core Java</td>
                                    </tr>
                                    <tr>
                                        <td>1CM6</td>
                                        <td>Practical-II :Tally (ERP 9)& MSOffice</td>
                                        <td>2CM6</td>
                                        <td>Practical-II : HTML ,JavaScript</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-responsive" > 
                            <table class="table table-bordered text-center tbl_custom">
                                <thead>
                                    <tr>
                                        <th colspan="4">MCM Part II</th>
                                    </tr>
                                    <tr>
                                        <th width="15%">Course Code</th>
                                        <th width="30%">Semester- 3</th>
                                        <th width="15%">Course Code </th>
                                        <th width="30%">Semester- 4</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>3CM1</td>
                                        <td>Advance Database Management System</td>
                                        <td>4CM1</td>
                                        <td>ASP.Net</td>
                                    </tr>
                                    <tr>
                                        <td>3CM2</td>
                                        <td>Principles & Techniques
                                            of Management
                                        </td>
                                        <td>4CM2</td>
                                        <td>Electives: 
                                            (i) Advance Java 
                                            (ii) Android Programming 
                                            (iii) Python
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3CM3</td>
                                        <td>Electives : 
                                            (i) PHP & MySQL 
                                            (ii) VB.Net 
                                            (iii) C#.Net
                                        </td>
                                        <td>4CM3</td>
                                        <td>Elective Foundation: 
                                            (i) Big Data &Hadoop 
                                            (ii) Software Engineering (iii)Strategic Management
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3CM4</td>
                                        <td>Compulsory Foundation 
                                            (i) Research Methodology
                                        </td>
                                        <td>4CM4</td>
                                        <td>FC2 Advances in Information Technology
                                            CDC2 Parallel Computing
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3CM5</td>
                                        <td>Practical- I :SQL & PL/SQL</td>
                                        <td>4CM5</td>
                                        <td>Practical-I:ASP.Net</td>
                                    </tr>
                                    <tr>
                                        <td>3CM6</td>
                                        <td>Practical-II :Electives</td>
                                        <td>4CM6</td>
                                        <td>Practical-II:Electives</td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td>Project</td>
                                        <td>Project</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div> -->
                    </div>
                    <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">                                
                        <div class="inner-title"  >
                            <h3>Affiliation
                            </h3>
                           
                        </div> 
                        <div class="text-left">                         
                            <p>RTM Nagpur University </p>
                        </div> 
                    </div>
                    <div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">                                
                        <div class="inner-title"  >
                            <h3>Scope  and Prospects
                            </h3>
                           
                        </div> 
                        <ul class="list-item"> 
                            <li><strong>Scope :</strong> MBA (Economics), M.Sc. Economics , MBA </li>
                            <li><strong>Prospects / Scope :</strong> Investment Banker, Financial Analyst ,Statistician </li>
                        </ul>
                    </div>
                 
                    <div class="tab-pane fade" id="tab6" role="tabpanel" aria-labelledby="tab6-tab">                                
                        <div class="inner-title"  >
                            <h3>Fees And Intake
                            </h3>
                           
                        </div> 
                        <ul class="list-item"> 
                            <li><strong>Fees  :</strong> Rs.30,000 per year</li>
                            <li><strong>Intake :</strong>60 students </li>
                        </ul>
                    </div>  
            </div>            
                <div class="text-center mt-5">
                    <a class="button-text" href="https://raisoni.nopaperforms.com/rgi" target="_blank">Apply Now</a>
                </div>
            </div>
        </div>
    </div>
</section>

